import { Base } from 'layouts'
import { ClientList } from 'components'

import * as S from './styled'

export function Client() {
  return (
    <Base>
      <S.GridContainer container>
        <ClientList />
      </S.GridContainer>
    </Base>
  )
}
